<template>
    <form @submit="submitForm">
        <div class="d-flex" v-bind:class="{ 'm-2': slim, 'pt-4 pb-2 mb-3': !slim }">
            <input v-bind:disabled="loading" v-if="product.type === 'bucata' || product.type === 'legatura'" @focus="$event.target.select()"
                   type="number" min="0" class="form-control form-control-sm me-2 text-center" v-model="quantity"
                   inputmode="number"
                   pattern="[0-9]*"
                   @change="changeQuantity($event)"
                   v-bind:style="{
                    width: slim ? '100%' : '5rem',
                  }"
            >
            <input v-bind:disabled="loading" v-if="product.type === 'kg'" @focus="$event.target.select()"
                   type="number" step="0.5" min="0" class="form-control form-control-sm me-2 text-center" v-model="quantity"
                   inputmode="text"
                   pattern="[0-9]*(\.[0-9]{1,2})?"
                   @change="changeQuantity($event)"
                   v-bind:style="{
                    width: slim ? '100%' : '5rem',
                  }"
            >
            <button v-if="!loading" class="btn btn-primary btn-shadow btn-sm" type="submit">{{ slim ? '' : translate('add') }}<i class="ci-cart fs-base ms-1"></i></button>
            <button v-else disabled class="btn btn-primary btn-shadow btn-sm" type="button"><i class="ci-loading fs-base ms-1"></i></button>
        </div>
        <div v-if="error !== null" class="alert alert-danger d-flex m-2 p-2" role="alert">
            <span>{{ error }}</span>
        </div>
    </form>
</template>

<script>

export default {
    props: {
        lang: String,
        slim: Boolean,
        product: Object,
    },
    data () {
        return {
            loading: false,
            quantity: 1,
            error: null,
            translations: {
                en: {
                    add: 'Add to cart',
                },
                ro: {
                    add: 'Adauga in cos',
                }
            }
        }
    },
    methods: {
        translate (key) {
            return this.translations[this.lang][key] || `${this.lang}.${key}`
        },
        changeQuantity (event) {
            this.error = null;
            let quantity = parseFloat(event.target.value.replace(',', '.'))
            if (isNaN(quantity)) {
                quantity = 0
            }
            if (quantity < 0) {
                return
            }

            this.quantity = quantity
        },
        submitForm ($event) {
            this.error = null;
            $event.preventDefault()
            if (!this.loading) {
                this.loading = true
                axios.post('/api/cart/add', {
                    'id': this.product.id,
                    'quantity': this.quantity
                })
                    .then(response => {
                        this.loading = false
                        window.EventBus.$emit('refreshCart', {})
                    })
                    .catch(error => {
                        if (error.response) {
                            this.error = error.response.data.status
                        } else {
                            this.error = 'Ne pare rau, o eroare a aparut'
                        }
                        this.loading = false
                    })
            }
        },
    }
}
</script>
